import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import imgComplete from '../../assets/images/pending.svg';

const Declined = (props) => {
  const config = useConfig();
  const { navigate, checkinData, searchParams, params } = props;
  useEffect(() => {
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${searchParams.get('key')}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleButtonClick = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    const workflowType = get(params, 'workflowType') || 'text2apply';

    dispatch(newNextAction({
      key: params.key,
      workflowType,
    }));
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <img src={imgComplete} alt="" />
        <h1>Agreement Signature Pending</h1>
        <p>{get(checkinData, 'data.data.message')}</p>
        {
          get(checkinData, 'data.data.showCallToActionButton')
            && (
            <div className="footer" style={{ marginTop: 50 }}>
              <div className="row">
                <div className="col">
                  <button type="button" onClick={handleButtonClick} className="btn arrow">Continue Signing Loan Document</button>
                </div>
              </div>
            </div>
            )
        }
      </div>
    </div>
  );
};

Declined.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Declined);
